'use server'

import { cookies } from "next/headers";

import {
  PREVIEW_COOKIE,
  PREVIEW_COOKIE_MAX_AGE,
  isPreviewGateEnabled,
  previewToken,
} from "@/lib/preview-gate";

/**
 * Verify the pre-launch access code and unlock the app for this browser.
 *
 * The cookie stores a hash of the code rather than the code itself (see previewToken), so
 * the shared secret is never sitting in plaintext in a tester's browser. The gate in
 * proxy.ts recomputes the same hash to validate it.
 */
export async function unlockBeta(password: string) {
  // If the gate is off there is nothing to unlock, and hashing an undefined password would
  // mint a cookie that can never validate.
  if (!isPreviewGateEnabled()) return { success: true };

  if (password !== process.env.BETA_PASSWORD) {
    return { success: false, error: "Invalid access code" };
  }

  const cookieStore = await cookies();
  cookieStore.set(PREVIEW_COOKIE, await previewToken(password), {
    httpOnly: true,
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax",
    maxAge: PREVIEW_COOKIE_MAX_AGE,
    path: "/",
  });

  return { success: true };
}
